import { Pipe, PipeTransform } from '@angular/core';
import { truncate } from 'lodash';

@Pipe({
    name: 'truncate',
})
export class TruncatePipe implements PipeTransform {
    transform(value: string | null | undefined, limit: number): string {
        if (!value) return '';

        return truncate(value, { length: limit });
    }
}
